import { Action, Dispatch } from "redux";
import { Environments, GetArtefactVersion } from "@emisgroup/cohort-builder-kit";
import { ProgressSpinnerSlice } from "../../../ProgressSpinner/Index";
import { handleException } from "../../../../ErrorMessages/helper";
import { VersioningSlice } from "./redux";

/**
* Method for fetching the service
*/
export const GetVersioning = async (
  dispatch: Dispatch<Action>,
  // eslint-disable-next-line @typescript-eslint/ban-types
  translate: Function,
  env: Environments,
  accessToken: string,
  extractGuid: string,
  currentVersion?: string,): Promise<void> => {
  try {
    dispatch(ProgressSpinnerSlice.actions.showProgressBar(translate("LoadingMessage.VersionList")));
    const response = await GetArtefactVersion(extractGuid, env, accessToken);
    if (response && response["data"] && response["data"]["payload"]) {
      const list = response["data"]["payload"]["versionList"];
      if (currentVersion) {
        const filteredList = list.filter((item: any) => {
          return item.extractVersion === currentVersion;
        });
        dispatch(VersioningSlice.actions.setExportStatus({
          currentVersion: currentVersion,
          status: filteredList[0].exportStatus
        }));
      }
      dispatch(VersioningSlice.actions.setVersionList(list));
      dispatch(ProgressSpinnerSlice.actions.hideProgressBar());
    }
  } catch (ex) {
    handleException(ex, dispatch, "VersionListErrMessage");
  }
};
